import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Copy, BookOpenCheck } from "lucide-react";

const BIBTEX = `@misc{alam2026prometheusebm,
  author       = {Mushfiqul Alam},
  title        = {{PROMETHEUS-EBM}: A Living Anti-Contamination Benchmark
                  for Epistemic Belief Modeling in Frontier LLMs},
  year         = {2026},
  howpublished = {\\url{https://www.prometheusebm.com/}},
  note         = {Version V5, deep\\_probe n=1459,
                  released via PyPI as \\texttt{prometheus-ebm}}
}`;

export default function CiteBlock() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(BIBTEX);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };
  return (
    <section
      id="cite"
      data-testid="cite-section"
      className="relative py-24 px-6 lg:px-10 border-t border-white/5 bg-[#060606]"
    >
      <div className="absolute inset-0 tech-grid opacity-25 pointer-events-none" />
      <div className="relative max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <div className="chapter-label mb-6">◆ · Cite the Benchmark</div>
          <h2 className="font-serif-display text-3xl sm:text-4xl text-neutral-100 mb-2 leading-tight">
            If this work shaped your thinking,
            <span className="text-[#FF4D00]"> credit the fire</span>.
          </h2>
          <p className="text-neutral-400 text-sm font-mono mt-4 max-w-2xl leading-relaxed">
            A single BibTeX for the benchmark. For specific runs or findings,
            each Research Update carries its own citation.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 border border-white/10 bg-[#0d0d0d]"
        >
          <div className="flex items-center justify-between px-5 py-3 border-b border-white/5 bg-[#0a0a0a]">
            <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] uppercase text-[#00F0FF]">
              <BookOpenCheck className="w-3.5 h-3.5" /> cite · bibtex
            </div>
            <button
              onClick={copy}
              data-testid="copy-master-bibtex"
              className="font-mono text-[10px] tracking-[0.22em] uppercase flex items-center gap-1.5 text-neutral-400 hover:text-[#FF4D00] transition-colors"
            >
              {copied ? (
                <>
                  <Check className="w-3.5 h-3.5" /> copied
                </>
              ) : (
                <>
                  <Copy className="w-3.5 h-3.5" /> copy
                </>
              )}
            </button>
          </div>
          <pre className="px-5 py-5 overflow-x-auto font-mono text-[12.5px] text-neutral-300 whitespace-pre leading-relaxed">
            {BIBTEX}
          </pre>
        </motion.div>
      </div>
    </section>
  );
}
